import React from "react";
import Reveal from "./Reveal";

export default function SectionHead({ no = "", title, lede, kicker }) {
    return (
        <Reveal className="mb-10 sm:mb-14">
            <div className="flex items-baseline gap-4 border-b border-white/10 pb-5 mb-6">
                {no && (
                    <span className="font-display text-stroke text-4xl sm:text-5xl font-semibold leading-none">{no}</span>
                )}
                <div className="min-w-0">
                    {kicker && (
                        <p className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.3em] text-amber mb-1.5">
                            {kicker}
                        </p>
                    )}
                    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl text-paper leading-tight">{title}</h2>
                </div>
            </div>
            {lede && <p className="max-w-3xl text-base sm:text-lg leading-relaxed text-ash">{lede}</p>}
        </Reveal>
    );
}
